(function ($) {
  Drupal.behaviors.dw_color_correctors_transformation_carousel_mob = {
    attach: function (context) {
      $('.js-dwcc-carousel__v2', context).once(function () {
        // Handle single play-through
        var hasFaded = false;
        var offset;

        if ($('.js-dwcc-carousel__v2').data('scrollmagic') === 1) {
          // Hide the container initially.
          $('.js-dwcc-carousel__v2').parent('.el_boutique_wrapper').css({
            opacity: '0',
            'margin-top': '5%'
          });
        }

        // Animation
        function triggerFade() {
          if (hasFaded === false) {
            hasFaded = true;
            $('.js-dwcc-carousel__v2').parent('.el_boutique_wrapper').animate(
              {
                opacity: 1,
                marginTop: '0'
              },
              600,
              'easeOutQuad'
            );
          } else {
            return;
          }
        }

        $(window).on('load', function () {
          // Fade in the module on the page, if requested.
          if ($('.js-dwcc-carousel__v2').data('scrollmagic') === 1) {
            // Put in window load so that the page height is ready
            // by the time we get to animating.
            // Init scrollMagic Controller Class
            var controller = new ScrollMagic.Controller();

            if ($('.js-dwcc-carousel__v2').data('offset')) {
              offset = $('.js-dwcc-carousel__v2').data('offset');
            } else {
              offset = 0;
            }

            // Init scrollMagic Scene Class
            var triggerFadeScene = new ScrollMagic.Scene({
              triggerElement: '.js-dwcc-carousel__v2',
              offset: offset
            }).on('start', function () {
              triggerFade();
            });

            controller.addScene([triggerFadeScene]);
          }
        });
      });
    }
  };
})(jQuery);
